import React from 'react'
import TableMui from 'src/components/TableMui'
import { TableMuiLabel } from 'src/components/TableMui/styles'
import { formatDateUTC } from 'src/utils/formatDate'
import { useSelector } from 'src/utils/store'
import { BatchInfoAddress } from '../../StockMovementsTypes'

interface BatchInfoTableProps {
  onRowClick: (addressIndex: number) => void
}

interface BatchInfoTableRow {
  addressFormated: string
  dueDate: string
  quantity: number
  idStockBatchDue: number
}

export const BatchInfoTable = ({ onRowClick }: BatchInfoTableProps) => {
  const batchInfo = useSelector((state) => state.stockMovements.batchInfo)

  const resolveTableRows = () => (
    batchInfo?.addresses.map((address) => ({
      addressFormated: address.addressFormated,
      dueDate: formatDateUTC(address.dueDate, 'DD/MM/YYYY'),
      quantity: address.quantity,
      idStockBatchDue: address.idStockBatchDue,
    }))
  )

  const addBatchItem = (row: BatchInfoTableRow) => {
    const addressIndex = batchInfo?.addresses.findIndex((address: BatchInfoAddress) => address.idStockBatchDue === row.idStockBatchDue)
    if (addressIndex === -1) return

    onRowClick(addressIndex!)
  }

  return (
    <TableMui
      columns={[
        { id: 'addressFormated', label: 'Endereço', width: '33.33%' },
        { id: 'dueDate', label: 'Validade', width: '33.33%' },
        { id: 'quantity', label: 'Quantidade', width: '33.33%' },
      ]}
      rows={resolveTableRows()}
      tableLabel={(<TableMuiLabel>{`Lote ${batchInfo?.idBatch}`}</TableMuiLabel>)}
      onRowClick={(row) => addBatchItem(row)}
      thinLine
      testId='batch-info-table'
    />
  )
}
